import { render, staticRenderFns } from "./QuestionLeftBar.vue?vue&type=template&id=2df17742&scoped=true"
import script from "./QuestionLeftBar.vue?vue&type=script&lang=js"
export * from "./QuestionLeftBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df17742",
  null
  
)

export default component.exports